"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ontology = void 0;
var interfaces_1 = require("./interfaces");
/**
 * A class to handle the ontology for a graph
 * Contains function to get info related to an obj, an activity or an exercice
 * Contains function to do debug in ZPDES (check if an activity has an exercice for exemple)
 * @param params : same as the params used to initialize AI algorithms
 */
var Ontology = /** @class */ (function () {
    function Ontology(params) {
        this.objectives = {};
        this.activitiesOfObj = {};
        this.exercises_ontology = {};
        this.adaptiveIds = {};
        this.exercices_in_act = {};
        this.startWithInitialTest = false;
        this.initialTestDatas = {};
        this.params = params;
        var idModule = params["graph"]["main_act"];
        var ModuleData = params["graph"]["graph"];
        var ontology = params["graph"]["exercises_ontology"];
        this.objectives = ModuleData[idModule]["subgroups"][0];
        // remplissage des objectifs, activités et exercices
        for (var _i = 0, _a = this.objectives; _i < _a.length; _i++) {
            var obj = _a[_i];
            this.activitiesOfObj[obj] = ModuleData[obj]["subgroups"][0];
            for (var _b = 0, _c = this.activitiesOfObj[obj]; _b < _c.length; _b++) {
                var act = _c[_b];
                for (var i = 0; i < ontology.length; i++) {
                    if (act == ontology[i]["id"]) {
                        if (this.params.algo_name == interfaces_1.AIEnginesIDs.adaptiveTest && ontology[i]["adaptiveIds"]) {
                            var adaptiveExercises = ontology[i]["adaptiveIds"];
                            this.exercices_in_act[act] = adaptiveExercises;
                            for (var _d = 0, adaptiveExercises_1 = adaptiveExercises; _d < adaptiveExercises_1.length; _d++) {
                                var exID = adaptiveExercises_1[_d];
                                this.exercises_ontology[exID] = { 'objID': obj, 'actID': act };
                            }
                        }
                        else {
                            var exos = ontology[i]['exerciseIds'];
                            this.exercices_in_act[act] = exos;
                            for (var _e = 0, exos_1 = exos; _e < exos_1.length; _e++) {
                                var exID = exos_1[_e];
                                this.exercises_ontology[exID] = { 'objID': obj, 'actID': act };
                            }
                        }
                    }
                }
            }
        }
        //separate initialtest data 
        if (this.params["graph"]["initialTest"]) {
            this.startWithInitialTest = true;
            this.initialTestDatas["objectiveId"] = this.params["graph"]["initialTest"]['objectiveId'];
            this.initialTestDatas["activityId"] = this.params["graph"]["initialTest"]['activityId'];
            for (var i = 0; i < ontology.length; i++) {
                if (this.initialTestDatas["activityId"] == ontology[i]["id"]) {
                    var exos = ontology[i]['exerciseIds'];
                    this.initialTestDatas["exercises"] = exos;
                }
            }
        }
    }
    /**
     *
     * @param actID
     * @returns list of exercices in the activity
     */
    Ontology.prototype.get_exercices_in_activity = function (actID) {
        try {
            return this.exercices_in_act[actID];
        }
        catch (_a) {
            throw new Error("activity not in ontology");
        }
    };
    /**
     *
     * @param objID
     * @returns list of activity in the obj
     */
    Ontology.prototype.get_activities_in_objective = function (objID) {
        try {
            return this.activitiesOfObj[objID];
        }
        catch (_a) {
            throw new Error("objectif not in ontology");
        }
    };
    /**
     *
     * @param exID
     * @returns the activity in which the exercice is
     */
    Ontology.prototype.get_activityID_of_exercice = function (exID) {
        try {
            return this.exercises_ontology[exID].actID;
        }
        catch (_a) {
            throw new Error("exercise not in ontology");
        }
    };
    /**
     *
     * @param actID
     * @returns the obj in which the activity is
     */
    Ontology.prototype.get_objectiveID_of_activity = function (actID) {
        var keys = Object.keys(this.activitiesOfObj);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var i = keys_1[_i];
            for (var j = 0; j < this.activitiesOfObj[i].length; j++) {
                if (this.activitiesOfObj[i][j] == actID) {
                    return i;
                }
            }
        }
        throw new Error("activity not in ontology");
    };
    /**
     *
     * @param actID
     * @returns the position of the activity in its corresponding objective
     */
    Ontology.prototype.get_activity_position_in_obj = function (actID) {
        var objID = this.get_objectiveID_of_activity(actID);
        return this.activitiesOfObj[objID].indexOf(actID);
    };
    Ontology.prototype.get_objective_position = function (objID) {
        return this.objectives.indexOf(objID);
    };
    /**
     *
     * @param exID
     * @returns a dictionnary containing 'objId' and 'actId' of an exercice
     */
    Ontology.prototype.get_exercices_info = function (exID) {
        try {
            return this.exercises_ontology[exID];
        }
        catch (_a) {
            throw new Error("exercice not in ontology");
        }
    };
    /**
     * checks if some activities have no exercice in the data.json
     * @returns list of activityId that have no exercice
     */
    Ontology.prototype.get_activities_with_no_exercices = function () {
        var all_activities = [];
        var activities = this.activitiesOfObj;
        var keys = Object.keys(this.activitiesOfObj);
        keys.forEach(function (key) {
            all_activities.push(Array.from(activities[key].values()));
        });
        var act_with_exo = Object.keys(this.exercices_in_act);
        var act_without_exo = {};
        for (var _i = 0, _a = all_activities.flat(); _i < _a.length; _i++) {
            var act = _a[_i];
            if (!act_with_exo.includes(act)) {
                var ob = this.get_objectiveID_of_activity(act);
                if (!Object.keys(act_without_exo).includes(ob)) {
                    act_without_exo[ob] = [];
                }
                act_without_exo[ob].push(act);
            }
        }
        return act_without_exo;
    };
    /**
     *
     * @param exID
     * @returns code (MxOx) of the activity and objective related to the exercice
     */
    Ontology.prototype.get_code_of_exo = function (exID) {
        var info = this.get_exercices_info(exID);
        return "O" + (this.get_objective_position(info.objID) + 1) + "A" + (this.get_activity_position_in_obj(info.actID) + 1);
    };
    /**
     *
     * @returns number of activities in the module
     */
    Ontology.prototype.get_number_of_activities = function () {
        return Object.keys(this.exercices_in_act).length;
    };
    Ontology.prototype.isExerciseInInitialTest = function (exID) {
        if (this.startWithInitialTest) {
            return this.initialTestDatas["exercises"].includes(exID);
        }
        else {
            return false;
        }
    };
    Ontology.prototype.getInitialTest_ObjectiveId_And_ActivityId = function () {
        return [this.initialTestDatas['objectiveId'], this.initialTestDatas['activityId']];
    };
    Ontology.prototype.computeAdaptiveTestDifficulties = function () {
        var difficulties = {};
        for (var _i = 0, _a = this.objectives; _i < _a.length; _i++) {
            var obj = _a[_i];
            for (var i = 0; i < this.activitiesOfObj[obj].length; i++) {
                difficulties[this.activitiesOfObj[obj][i]] = -(i + 1) / this.activitiesOfObj[obj].length;
            }
        }
        return difficulties;
    };
    Ontology.prototype.computeLinearDifficulties = function (normalizeDiff) {
        if (normalizeDiff === void 0) { normalizeDiff = true; }
        var difficulties = {};
        var maxDiff = 0; //1.0 * this.objectives.length * this.activitiesOfObj[this.objectives.at(-1)].length;
        var linarDiff = 1;
        for (var o = 0; o < this.objectives.length; o++) {
            var obj = this.objectives[o];
            for (var a = 0; a < this.activitiesOfObj[obj].length; a++) {
                //diffculty between 0(diffficult) and 1 (easy)
                difficulties[this.activitiesOfObj[obj][a]] = 1 - linarDiff / this.get_number_of_activities();
                linarDiff += 1;
            }
        }
        return difficulties;
    };
    return Ontology;
}());
exports.Ontology = Ontology;
